var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateProposal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "url(#paint0_linear_632_1191)",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 16,
    height: 8,
    rx: 1,
    fill: "url(#paint1_linear_632_1191)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10H7",
    stroke: "#88CAB8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12H7",
    stroke: "#88CAB8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14H7",
    stroke: "#88CAB8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 6C19.1634 6 18.8906 6.27281 18.8906 6.60931V10.3908C18.8906 10.7273 19.1634 11.0001 19.4999 11.0001C19.8364 11.0001 20.1092 10.7273 20.1092 10.3908V6.60934C20.1093 6.27284 19.8365 6 19.4999 6Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3908 7.89087H17.6093C17.2728 7.89087 17 8.16368 17 8.50018C17 8.83668 17.2728 9.10949 17.6093 9.10949H21.3908C21.7273 9.10949 22.0001 8.83668 22.0001 8.50018C22.0001 8.16368 21.7273 7.89087 21.3908 7.89087Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_632_1191",
    x1: 24,
    y1: -0.00000523869,
    x2: -0.598279,
    y2: 0.629711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAF5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CE0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_632_1191",
    x1: 4,
    y1: 16.5,
    x2: 35.68,
    y2: 26.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDFEF0",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateProposal);
export default __webpack_public_path__ + "static/media/createProposal.e0edc298ed5d7bea7fb3201917d39b99.svg";
export { ForwardRef as ReactComponent };